import moment from "moment";
import { Card, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import FormField from "../../components/FormField";
import DatePicker from "../../components/DatePicker";
import Typography from "../../components/Typography";
import Autocomplete from "../../components/Autocomplete";
import PhoneNumberInput from "../../components/PhoneNumberInput";

import CustomStatusCell, { StatusByScreen } from "../../components/CustomStatusCell";
import ProfileService, { IDataUpdateOrganizationProfile } from "../../services/identity/profile.service";

import { ICodename } from "../../commons/interfaces";
import { Gender, Mode } from "../../constants/enums";
import { IDetailUser } from "../../containers/staff/edit";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";



const CardStaffInfo = (props: {
    mode: number;
    hidenStatus?: boolean;
    newLableStaff?: string;
    hidenIdCardInfo?: boolean;
    hidenPassportInfo?: boolean;
    dataDetailUser?: IDetailUser;
    listCountrySelect?: ICodename[];

    onCallBack?: () => void;
}) => {
    const strings = useStrings();

    const {
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [modeBasicInfo, setModeBasicInfo] = useState<number>(Mode.View);
    const [errorOrganizationUserProfile, setErrorOrganizationUserProfile] = useState<{ [key in keyof IDataUpdateOrganizationProfile]?: string }>({});
    const [dataOrganizationUserProfile, setDataOrganizationUserProfile] = useState<IDataUpdateOrganizationProfile>({} as IDataUpdateOrganizationProfile);

    useEffect(() => {
        setModeBasicInfo(props.mode);
    }, [props.mode]);

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(props.dataDetailUser?.id)) {
            setErrorOrganizationUserProfile({});
            setDataOrganizationUserProfile(props.dataDetailUser?.organizationUserProfile);
        }
    }, [props.dataDetailUser?.id]);

    const genderList: ICodename[] = useMemo(() => [
        { code: Gender.Male, name: strings.Common.MALE },
        { code: Gender.Female, name: strings.Common.FEMALE },
        // { code: Gender.Other, name: strings.Common.OTHER },
    ], [strings]);

    const valueDate = (value: any) => {
        const ischeck = (Helpers.isNullOrEmpty(value) || value === "0" || value === 0);
        return ischeck ? undefined : Number(value) * 1000;
    };

    const onChangeValueOrgUserProfile = (key: string, value: any) => {
        setDataOrganizationUserProfile(prev => ({ ...prev, [key]: value }));
        setErrorOrganizationUserProfile(prev => ({ ...prev, [key]: undefined }));
    }

    const checkValidateDataOrgUserProfile = () => {
        let checked: boolean = true;

        const newErrorByOrganization: any = { ...errorOrganizationUserProfile };

        if (Helpers.isNullOrEmpty(dataOrganizationUserProfile.lastName)) {
            newErrorByOrganization["lastName"] = strings.Common.REQUIRED;
            checked = false;
        }

        if (Helpers.isNullOrEmpty(dataOrganizationUserProfile.firstName)) {
            newErrorByOrganization["firstName"] = strings.Common.REQUIRED;
            checked = false;
        }

        if (Helpers.isNullOrEmpty(dataOrganizationUserProfile.phoneNumber)) {
            newErrorByOrganization["phoneNumber"] = strings.Common.REQUIRED;
            checked = false;
        } else {
            if (dataOrganizationUserProfile.phoneNumber?.length < 8) {
                newErrorByOrganization["phoneNumber"] = strings.Common.WRONG_PHONE_NUMBER;
                checked = false;
            }
        }

        if (Helpers.isNullOrEmpty(dataOrganizationUserProfile.email)) {
            newErrorByOrganization["email"] = strings.Common.REQUIRED;
            checked = false;
        } else {
            if (!Helpers.isValidEmail(dataOrganizationUserProfile.email)) {
                newErrorByOrganization["email"] = strings.Common.INVALID_EMAIL;
                checked = false;
            }
        }

        if (!Helpers.isNullOrEmpty(valueDate(dataOrganizationUserProfile.dateOfBirth)) &&
            Number(dataOrganizationUserProfile?.dateOfBirth) >= moment().unix()) {
            newErrorByOrganization["dateOfBirth"] = strings.Common.INVALID_TIME;
            checked = false;
        }

        if (!props.hidenIdCardInfo) {
            if (!Helpers.isNullOrEmpty(valueDate(dataOrganizationUserProfile?.idCardIssuedDate)) &&
                Number(dataOrganizationUserProfile?.idCardIssuedDate) >= moment().unix()) {
                newErrorByOrganization["idCardIssuedDate"] = strings.Common.INVALID_TIME;
                checked = false;
            }

            if (!Helpers.isNullOrEmpty(dataOrganizationUserProfile?.idCardNo) &&
                dataOrganizationUserProfile?.idCardNo?.length < 12) {
                newErrorByOrganization["idCardNo"] = strings.Staff.WRONG_ID_CARD_NO_FORMAT;
                checked = false;
            }

            if (!Helpers.isNullOrEmpty(dataOrganizationUserProfile?.socialInsuranceCode) &&
                dataOrganizationUserProfile?.socialInsuranceCode?.length < 10) {
                newErrorByOrganization["socialInsuranceCode"] = strings.Staff.WRONG_SOCIAL_INSURANCE_CODE_FORMAT;
                checked = false;
            }
        }

        if (!props.hidenPassportInfo) {
            if (!Helpers.isNullOrEmpty(dataOrganizationUserProfile?.passportNo) &&
                dataOrganizationUserProfile?.passportNo?.length < 12) {
                newErrorByOrganization["passportNo"] = strings.Staff.WRONG_PASSPORT_NO_CODE_FORMAT;
                checked = false;
            }
        }

        if (!checked) {
            setErrorOrganizationUserProfile(newErrorByOrganization);
        }

        return checked;
    };

    const handleUpdateOrganizationUserProfile = async () => {
        if (!checkValidateDataOrgUserProfile()) {
            return
        } else {
            try {
                onShowLoading();

                await ProfileService.updateOrganizationProfile([{
                    id: dataOrganizationUserProfile?.id,
                    userId: dataOrganizationUserProfile?.userId,
                    userType: dataOrganizationUserProfile?.userType,
                    organizationId: dataOrganizationUserProfile?.organizationId,

                    gender: dataOrganizationUserProfile?.gender || 0,
                    lastName: dataOrganizationUserProfile?.lastName,
                    firstName: dataOrganizationUserProfile?.firstName,
                    dateOfBirth: Number(dataOrganizationUserProfile?.dateOfBirth || 0),
                    email: dataOrganizationUserProfile?.email,
                    phoneNumber: dataOrganizationUserProfile?.phoneNumber,

                    idCardNo: dataOrganizationUserProfile?.idCardNo,
                    idCardIssuedPlace: dataOrganizationUserProfile?.idCardIssuedPlace,
                    idCardIssuedDate: Number(dataOrganizationUserProfile?.idCardIssuedDate || 0),
                    socialInsuranceCode: dataOrganizationUserProfile?.socialInsuranceCode,
                    employmentDate: Number(dataOrganizationUserProfile?.employmentDate || 0),

                    passportNo: dataOrganizationUserProfile?.passportNo,
                    passportIssuedPlace: dataOrganizationUserProfile?.passportIssuedPlace,
                    passportExpiredDate: Number(dataOrganizationUserProfile?.passportExpiredDate || 0),
                    nationality: dataOrganizationUserProfile?.nationality,
                }]);

                props.onCallBack &&
                    await props.onCallBack();

                setModeBasicInfo(Mode.View);

                onSuccess(strings.format(strings.Staff.UPDATE_SUCCESS, props.newLableStaff));
            } catch (error: any) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    };

    const onCancel = () => {
        setModeBasicInfo(Mode.View);
        setErrorOrganizationUserProfile({});
        setDataOrganizationUserProfile({ ...props.dataDetailUser?.organizationUserProfile });
    };

    const onSubmit = () => {
        if (modeBasicInfo === Mode.View) {
            setModeBasicInfo(Mode.Update);
        } else {
            handleUpdateOrganizationUserProfile();
        }
    }

    return (
        <Card>
            <Box p={2}>
                <Box sx={{
                    gap: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Box sx={{ gap: 2, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                        <Typography variant="h5">
                            {strings.format(strings.Staff.BASIC_INFO, props.newLableStaff)}
                        </Typography>
                        {
                            !props.hidenStatus &&
                            !Helpers.isNullOrEmpty(props.dataDetailUser?.id) &&
                            !Helpers.isNullOrEmpty(props.dataDetailUser?.organizationUserProfile?.status) &&
                            <Box >
                                <CustomStatusCell
                                    isDetail
                                    statusByScreen={StatusByScreen.screenStaff}
                                    status={props.dataDetailUser?.organizationUserProfile?.status}
                                />
                            </Box>
                        }
                    </Box>
                    {
                        (props.mode !== Mode.View) &&
                        !Helpers.isNullOrEmpty(props.dataDetailUser?.id) &&
                        <Box sx={{ gap: 1, display: "flex", flexWrap: "wrap", alignItems: "center", }}>
                            {
                                (modeBasicInfo !== Mode.View) &&
                                <Button color="secondary" onClick={onCancel}>
                                    {strings.Common.CANCEL}
                                </Button>
                            }
                            <Button onClick={onSubmit}>
                                {(modeBasicInfo === Mode.View) ? strings.Common.EDIT : strings.Common.SAVE}
                            </Button>
                        </Box>
                    }
                </Box>

                {/* Basic info user */}
                <Grid container spacing={2} p={2}>
                    {/* LAST_NAME */}
                    <Grid item xs={12} md={6}>
                        <FormField
                            required
                            maxLength={255}
                            mode={modeBasicInfo}
                            label={strings.Staff.LAST_NAME}
                            placeholder={strings.Staff.ENTER_LAST_NAME}
                            defaultValue={dataOrganizationUserProfile?.lastName}
                            errorMessage={errorOrganizationUserProfile?.lastName}
                            onBlur={(value: any) => {
                                onChangeValueOrgUserProfile("lastName", value);
                            }}
                        />
                    </Grid>

                    {/* FIRST_NAME */}
                    <Grid item xs={12} md={6}>
                        <FormField
                            required
                            maxLength={255}
                            mode={modeBasicInfo}
                            label={strings.Staff.FIRST_NAME}
                            placeholder={strings.Staff.ENTER_FIRST_NAME}
                            defaultValue={dataOrganizationUserProfile?.firstName}
                            errorMessage={errorOrganizationUserProfile?.firstName}
                            onBlur={(value: any) => {
                                onChangeValueOrgUserProfile("firstName", value);
                            }}
                        />
                    </Grid>

                    {/* PHONE NUMBER */}
                    <Grid item xs={12} md={6}>
                        <PhoneNumberInput
                            required
                            country={"vn"}
                            mode={modeBasicInfo}
                            defaultValue={dataOrganizationUserProfile?.phoneNumber}
                            errorMessage={errorOrganizationUserProfile?.phoneNumber}
                            onChangeValue={(value: any) => {
                                onChangeValueOrgUserProfile("phoneNumber", value);
                            }}
                        />
                    </Grid>

                    {/* EMAIL */}
                    <Grid item xs={12} md={6}>
                        <FormField
                            required
                            maxLength={255}
                            mode={modeBasicInfo}
                            label={strings.Staff.EMAIL}
                            placeholder={strings.Staff.ENTER_EMAIL}
                            defaultValue={dataOrganizationUserProfile?.email}
                            errorMessage={errorOrganizationUserProfile?.email}
                            onBlur={(value: any) => {
                                onChangeValueOrgUserProfile("email", value);
                            }}
                        />
                    </Grid>

                    {/* GENDER */}
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            mode={modeBasicInfo}
                            data={genderList || []}
                            label={strings.Staff.GENDER}
                            placeholder={strings.Staff.SELECT_GENDER}
                            defaultValue={dataOrganizationUserProfile?.gender}
                            errorMessage={errorOrganizationUserProfile?.gender}
                            onChange={(value) => {
                                const newValue = value ? Number(value) : undefined;
                                onChangeValueOrgUserProfile("gender", newValue);
                            }}
                        />
                    </Grid>

                    {/* BIRTHDAY */}
                    <Grid item xs={12} md={6}>
                        <DatePicker
                            mode={modeBasicInfo}
                            label={strings.Staff.BIRTHDAY}
                            placeholder={strings.Staff.SELECT_BIRTHDAY}
                            errorMessage={errorOrganizationUserProfile?.dateOfBirth}
                            value={valueDate(dataOrganizationUserProfile?.dateOfBirth)}
                            onChangeValue={(value: any) => {
                                const newValue = value ? moment(value).unix() : undefined;
                                onChangeValueOrgUserProfile("dateOfBirth", newValue);
                            }}
                        />
                    </Grid>

                    {!props.hidenIdCardInfo &&
                        <>
                            {/* ID_CARD_NO */}
                            <Grid item xs={12} md={6}>
                                <FormField
                                    maxLength={12}
                                    type={"number"}
                                    mode={modeBasicInfo}
                                    label={strings.Staff.ID_CARD_NO}
                                    placeholder={strings.Staff.ENTER_ID_CARD_NO}
                                    defaultValue={dataOrganizationUserProfile?.idCardNo}
                                    errorMessage={errorOrganizationUserProfile?.idCardNo}
                                    onBlur={(value: any) => {
                                        const newValue = value ? ((Number(value) > 0) ? Number(value) : 0).toString() : undefined;
                                        onChangeValueOrgUserProfile("idCardNo", newValue);
                                    }}
                                />
                            </Grid>
                            {/* ID_CARD_ISSUED_DATE */}
                            <Grid item xs={12} md={6}>
                                <DatePicker
                                    mode={modeBasicInfo}
                                    label={strings.Staff.ID_CARD_ISSUED_DATE}
                                    placeholder={strings.Staff.ID_CARD_ISSUED_DATE}
                                    errorMessage={errorOrganizationUserProfile?.idCardIssuedDate}
                                    value={valueDate(dataOrganizationUserProfile?.idCardIssuedDate)}
                                    onChangeValue={(value: any) => {
                                        const newValue = value ? moment(value).unix() : undefined;
                                        onChangeValueOrgUserProfile("idCardIssuedDate", newValue);
                                    }}
                                />
                            </Grid>
                            {/* ID_CARD_ISSUED_PLACE */}
                            <Grid item xs={12} md={6}>
                                <FormField
                                    maxLength={255}
                                    mode={modeBasicInfo}
                                    label={strings.Staff.ID_CARD_ISSUED_PLACE}
                                    placeholder={strings.Staff.ENTER_ID_CARD_ISSUED_PLACE}
                                    defaultValue={dataOrganizationUserProfile?.idCardIssuedPlace}
                                    errorMessage={errorOrganizationUserProfile?.idCardIssuedPlace}
                                    onBlur={(value: any) => {
                                        onChangeValueOrgUserProfile("idCardIssuedPlace", value);
                                    }}
                                />
                            </Grid>
                            {/* SOCIAL_INSURANCE_CODE */}
                            <Grid item xs={12} md={6}>
                                <FormField
                                    maxLength={10}
                                    type={"number"}
                                    mode={modeBasicInfo}
                                    label={strings.Staff.SOCIAL_INSURANCE_CODE}
                                    placeholder={strings.Staff.ENTER_SOCIAL_INSURANCE_CODE}
                                    defaultValue={dataOrganizationUserProfile?.socialInsuranceCode}
                                    errorMessage={errorOrganizationUserProfile?.socialInsuranceCode}
                                    onBlur={(value: any) => {
                                        const newValue = value ? ((Number(value) > 0) ? Number(value) : 0).toString() : undefined;
                                        onChangeValueOrgUserProfile("socialInsuranceCode", newValue);
                                    }}
                                />
                            </Grid>
                        </>
                    }

                    {!props.hidenPassportInfo &&
                        <>
                            {/* PASSPORT NUMBER */}
                            <Grid item xs={12} md={6}>
                                <FormField
                                    maxLength={12}
                                    mode={modeBasicInfo}
                                    label={strings.Staff.PASSPORT_NUMBER}
                                    placeholder={strings.Staff.ENTER_PASSPORT_NUMBER}
                                    defaultValue={dataOrganizationUserProfile?.passportNo}
                                    errorMessage={errorOrganizationUserProfile?.passportNo}
                                    onBlur={(value: any) => {
                                        onChangeValueOrgUserProfile("passportNo", value);
                                    }}
                                />
                            </Grid>

                            {/* PASSPORT EXPDATE */}
                            <Grid item xs={12} md={6}>
                                <DatePicker
                                    mode={modeBasicInfo}
                                    views={["month", "year"]}
                                    label={strings.Staff.PASSPORT_EXPDATE}
                                    placeholder={strings.Staff.ENTER_PASSPORT_EXPDATE}
                                    errorMessage={errorOrganizationUserProfile?.passportExpiredDate}
                                    value={valueDate(dataOrganizationUserProfile?.passportExpiredDate)}
                                    onChangeValue={(value: any) => {
                                        const newValue = value ? moment(value).unix() : undefined;
                                        onChangeValueOrgUserProfile("passportExpiredDate", newValue);
                                    }}
                                />
                            </Grid>

                            {/* PASSPORT ISSUING COUNTRY */}
                            <Grid item xs={12} md={6}>
                                <Autocomplete
                                    mode={modeBasicInfo}
                                    data={props.listCountrySelect || []}
                                    label={strings.Staff.PASSPORT_ISSUING_COUNTRY}
                                    placeholder={strings.Staff.SELECT_PASSPORT_ISSUING_COUNTRY}
                                    defaultValue={dataOrganizationUserProfile?.passportIssuedPlace}
                                    errorMessage={errorOrganizationUserProfile?.passportIssuedPlace}
                                    onChange={(value) => {
                                        onChangeValueOrgUserProfile("passportIssuedPlace", value);
                                    }}
                                />
                            </Grid>

                            {/* NATIONALITY */}
                            <Grid item xs={12} md={6}>
                                <Autocomplete
                                    mode={modeBasicInfo}
                                    data={props.listCountrySelect || []}
                                    label={strings.Staff.NATIONALITY}
                                    placeholder={strings.Staff.SELECT_NATIONALITY}
                                    defaultValue={dataOrganizationUserProfile?.nationality}
                                    errorMessage={errorOrganizationUserProfile?.nationality}
                                    onChange={(value) => {
                                        onChangeValueOrgUserProfile("nationality", value);
                                    }}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </Box>
        </Card>
    );
};

export default CardStaffInfo;